<template lang="pug">
  .template-container(v-if="value", data-history-field="frequency_cap_params")
    toggle-button(:value="value.mode !== 'disabled'", @change="toggleMode",
        :labels="{checked: 'Active', unchecked: 'Inactive'}",
        :width="100", :height="26", :font-size="9")
    div(v-if="value.mode !== 'disabled'")
      frequency-cap-obj(type="click", :value="value.click", @change="updateValue", v-if="!combinedMode", @mode="updateMode")
      frequency-cap-obj(type="impression", :value="value.impression", @change="updateValue", v-if="!combinedMode", @mode="updateMode")
      frequency-cap-obj(type="combined", :value="value.combined", @change="updateValue", v-if="combinedMode", @mode="updateMode")
</template>

<style lang="scss"></style>
<script>
import FrequencyCapObj from './FrequencyCapObj';

export default {
  name: 'FrequencyCap',
  components: {
    FrequencyCapObj,
  },
  emits: ['input'],
  props: ['value'],
  methods: {
    /** ToggleButton @change payload is { value } — Active means mode !== disabled */
    toggleMode(e) {
      const active =
        e && typeof e === 'object' && 'value' in e
          ? !!e.value
          : this.value.mode === 'disabled';
      this.updateMode(active ? 'combined' : 'disabled');
    },
    updateMode(mode) {
      const newValue = JSON.parse(JSON.stringify(this.value));
      newValue.mode = mode;
      this.$emit('input', newValue);
    },

    updateValue(value) {
      const { cap, timeframe, fingerprint, type } = value;
      const typeNewValue = { cap, timeframe, fingerprint };
      const newValue = JSON.parse(JSON.stringify(this.value));
      newValue[type] = typeNewValue;
      this.$emit('input', newValue);
    },
  },

  computed: {
    combinedMode() {
      return this.value && this.value.mode === 'combined';
    },
  },
};
</script>
